module.exports = __webpack_public_path__ + "img/t1-20.ec9d5407.png";